// extracted by mini-css-extract-plugin
export default {"hidden":"chat-app-module--hidden--8981c"};